import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, tap } from 'rxjs';

@Injectable()
export class HttpAuthInterceptor implements HttpInterceptor {
  readonly router = inject(Router);
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap({
        error: (error: HttpErrorResponse) => {
          if (
            error.status === 401 ||
            //error.status === 500 ||
            error.status === 0
          ) {
            const returnUrl = this.router.parseUrl(this.router.url).queryParams[
              'returnUrl'
            ] as string | undefined;
            this.router.navigate(
              ['/login'],
              returnUrl ? { queryParams: { returnUrl } } : {},
            );
          }
        },
      }),
    );
  }
}
